import * as Q from "q";

import { SourceBase } from "DistributedTaskControls/Common/Sources/SourceBase";
import { SourceManager } from "DistributedTaskControls/Common/Sources/SourceManager";

import * as Build from "TFS/Build/Contracts";
import { BuildHttpClient5 } from "TFS/Build/RestClient";
import AdminResources = require("Admin/Scripts/Resources/TFS.Resources.Admin");

import * as Authorization_Contracts from "Checks/Authorization/Client/Contracts/PipelinePermissions";
import { IPipelinePermissionsRestClient, PipelinePermissionsClientName } from "Checks/Authorization/Client/RestClient/PipelinePermissions";

import { AdminServicesViewPageContext } from "Admin/Scripts/AdminServicesViewPageContext";
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import VSS_WebApi_Constants = require("VSS/WebApi/Constants")

import * as VSSContext from "VSS/Context";
import { VssConnection } from "VSS/Service";
import * as Utils_String from "VSS/Utils/String";

/**
 * @brief Source implementation for Tasks related communications with the server
 */
export class ServiceEndpointPolicySource extends SourceBase {

    public static getKey(): string {
        return "ServiceEndpointPolicySource";
    }

    public getPipelinePermissionsClient(): IPipelinePermissionsRestClient {
        if (!this._pipelinePermissionsClient) {
            this._pipelinePermissionsClient = AdminServicesViewPageContext.getPageContext().getRestClient(PipelinePermissionsClientName);
        }
        return this._pipelinePermissionsClient;
    }

    public getBuildRestClient(): BuildHttpClient5 {
        if (!this._buildRestClient) {
            const tfsConnection = new VssConnection(TFS_Host_TfsContext.TfsContext.getDefault().contextData);
            this._buildRestClient = tfsConnection.getHttpClient<BuildHttpClient5>(BuildHttpClient5, VSS_WebApi_Constants.ServiceInstanceTypes.TFS);
        }

        return this._buildRestClient;
    }

    public getResourcePipelinePermission(endpointId: string): IPromise<Authorization_Contracts.ResourcePipelinePermissions> {
        let resourcePipelinePermissionsPromise = Q.defer<Authorization_Contracts.ResourcePipelinePermissions>();
        this.getPipelinePermissionsClient().getPipelinePermissionsForResource(VSSContext.getDefaultWebContext().project.id, "endpoint", endpointId).then((permissions: Authorization_Contracts.ResourcePipelinePermissions) => {
            resourcePipelinePermissionsPromise.resolve(permissions);
        }, (err) => {
            resourcePipelinePermissionsPromise.reject(new Error(Utils_String.localeFormat(AdminResources.ErrorLoadingEndpointPolicy, "\r\n", err.message || err)));
        });
        return resourcePipelinePermissionsPromise.promise;
    }

    public authorizeResource(endpointId: string, shouldAuthorize: boolean): IPromise<Authorization_Contracts.ResourcePipelinePermissions> {

        let resourcePipelinePermissionsPromise = Q.defer<Authorization_Contracts.ResourcePipelinePermissions>();

        // Authorizing/Unauthorizing resources for all pipelines
        let resourcePipelinePermissions: Authorization_Contracts.ResourcePipelinePermissions = {
            allPipelines: {
                authorized: !!shouldAuthorize,
                authorizedBy: null,
                authorizedOn: null
            },
            pipelines: null,
            resource: {
                id: endpointId,
                type: "endpoint"
            }
        };

        this.getPipelinePermissionsClient().updatePipelinePermisionsForResource(resourcePipelinePermissions, VSSContext.getDefaultWebContext().project.id, "endpoint", endpointId).then((resourcePipelinePermissions: Authorization_Contracts.ResourcePipelinePermissions) => {
            resourcePipelinePermissionsPromise.resolve(resourcePipelinePermissions);
        }, (err) => {
            resourcePipelinePermissionsPromise.reject(new Error(Utils_String.localeFormat(AdminResources.ErrorSavingEndpointPolicy, "\r\n", err.message || err)));
        });
        return resourcePipelinePermissionsPromise.promise;
    }

    public getPipelineDefinitions(definitionIds: number[]): IPromise<Build.BuildDefinitionReference[]> {
        return this.getBuildRestClient().getDefinitions(VSSContext.getDefaultWebContext().project.id, null, null, null, null, null, null, null, definitionIds);
    }

    public static instance(): ServiceEndpointPolicySource {
        return SourceManager.getSource(ServiceEndpointPolicySource);
    }
    
    private _vssConnection: VssConnection;
    private _pipelinePermissionsClient: IPipelinePermissionsRestClient;
    private _buildRestClient: BuildHttpClient5;
}